export const hasChartData = (arr) =>
    Array.isArray(arr) &&
    arr.some((i) => Number(i?.value ?? i?.count ?? i?.amount ?? 0) > 0);

export const EmptyChart = ({ title = "Chưa có dữ liệu" }) => (
    <div className="h-[320px] w-full rounded-[16px] border border-dashed border-[#D2D5DA] bg-white/60 flex flex-col items-center justify-center gap-2">
        <div className="text-sm font-semibold text-gray-700">{title}</div>
        <div className="text-xs text-gray-500">Vui lòng thử đổi bộ lọc thời gian.</div>
    </div>
);